"use client";
import type { TabContentBlock as TabContentBlockProps } from "@/payload-types";
import React, { useState } from "react";
import { AlternateSectionBlock } from "./AlternateSectionBlock";
import { ColumnsLayoutBlock } from "./ColumnsLayoutBlock";
import { ContentBlock } from "./ContentBlock";
import { RowsLayoutBlock } from "./RowsLayoutBlock";
import { FaqBlock } from "./FaqBlock";

const blockComponents = {
  alternateSection: AlternateSectionBlock,
  rowsLayout: RowsLayoutBlock,
  columnsLayout: ColumnsLayoutBlock,
  content: ContentBlock,
  faq: FaqBlock,
};

export const TabContentBlock: React.FC<TabContentBlockProps> = (props) => {
  const { tabs } = props;

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [activeTab, setActiveTab] = useState(tabs?.[activeIndex]);

  return (
    <div className={`m-0 -mt-36 md:-mt-24 lg:-mt-16 relative z-20`}>
      {/* Onglets */}
      <div className="px-4 md:px-14 lg:px-32 mb-14 lg:mb-8">
        {tabs?.map((tab, index) => (
          <button
            key={index}
            onClick={() => {
              setActiveIndex(index);
              setActiveTab(tabs?.[index]);
            }}
            className={`mb-2 bg-transparent text-white text-lg md:text-lg xl:text-2xl pb-2 border-b-2 mr-4 xl:mr-6 last:mr-0 hover:font-semibold ${index === activeIndex ? "border-primary border-b-4 font-bold" : "border-white"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Affichage du contenu de l'onglet actif */}
      <div className="tab-content-render">
        {activeTab?.tabContent?.map((block, index) => {
          const { blockType } = block;

          if (blockType && blockType in blockComponents) {
            const Block = blockComponents[blockType];

            if (Block) {
              return (
                <div key={index}>
                  <div>
                    {/* @ts-expect-error there may be some mismatch between the expected types here */}
                    <Block {...block} disableInnerContainer />
                  </div>
                </div>
              );
            }

            return null;
          }
        })}
      </div>
    </div>
  );
};
